module.exports = __webpack_public_path__ + "024fdb7d371c52d675f24ba1257c0058.pdf";